<template>
  <div class="CoalModel_adjustHistory_box">
    <!-- 标题 -->
    <div class="CoalModel_adjustHistory_box_title">
      <el-page-header @back="getReturn" content="下载中心"> </el-page-header>
    </div>
    <el-divider></el-divider>
    <!-- 操作记录列表 -->
    <el-table
      v-loading="loading"
      :data="logList"
      stripe
      size="mini"
      style="width: 100%">
      <el-table-column
        align="center"
        type="index"
        label="序号"
        fixed
        width="120">
      </el-table-column>
      <el-table-column
        prop="operationTime"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="operationName"
        align="center"
        label="创建人">
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="任务状态">
      </el-table-column>
      <el-table-column
        align="center"
        label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '成功'" @click="handleUpLoad(scope.row)" type="primary" size="mini">下载</el-button>
          </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;">
      </el-pagination>
    </div>
  </div>
</template>
<script>
// import KtButton from '@/components/Core/KtButton'

export default {
  components: {
    // KtButton
  },
  data() {
    return {
      size: 'small',
      loading: false,
      pageNo: 1,
      pageSize: 10,
      // 表格数据
      logList: [],
      totalSize: 0
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      this.loading = true
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      params["searchFieldList[0].fieldName"] = 'moduleType'
      params["searchFieldList[0].singleValue"] = '1'
      let res = await this.$api.finance.getExportList(params);
      let resData = res.data.dtoList || [];
      this.logList = resData;
      this.totalSize = res.data.totalSize;
      this.loading = false;
    },

    // 返回列表页
    getReturn() {
      this.$emit('Adjust', true)
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo
      this.initData()
    },
    handleUpLoad(data){
      window.open(data.fileUrl)
    }
  }
}
</script>
<style scoped lang="scss">
  .CoalModel_adjustHistory_box {
    padding: 10px;
    .CoalModel_adjustHistory_box_title {
      padding: 10px;

      span:first-child {
        font-weight: 700;
        font-size: 32px;
        padding-right: 10px;
        cursor: pointer;
        vertical-align: middle;
      }

      span:last-child {
        font-weight: 700;
        font-size: 20px;
        vertical-align: middle;
      }
    }
  }
</style>
